import { render, staticRenderFns } from "./ProductionInformEditor.vue?vue&type=template&id=32a3e74e&"
import script from "./ProductionInformEditor.vue?vue&type=script&lang=js&"
export * from "./ProductionInformEditor.vue?vue&type=script&lang=js&"
import style0 from "./ProductionInformEditor.vue?vue&type=style&index=0&id=32a3e74e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports